import { motion } from "framer-motion";

interface SectionHeadingProps {
  subtitle?: string;
  title: string;
  className?: string;
  light?: boolean;
  as?: "h1" | "h2";
}

const SectionHeading = ({ subtitle, title, className = "", light, as = "h2" }: SectionHeadingProps) => {
  const HeadingTag = as;
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-50px" }}
      transition={{ duration: 0.6 }}
      className={`text-center mb-12 md:mb-16 ${className}`}
    >
      {subtitle && (
        <span className={`text-xs tracking-[0.3em] uppercase font-body ${light ? "text-shiro/50" : "text-muted-foreground"}`}>
          {subtitle}
        </span>
      )}
      <HeadingTag className={`font-display text-3xl md:text-5xl font-light mt-2 ${light ? "text-shiro" : "text-foreground"}`}>
        {title}
      </HeadingTag>
      <div className="w-12 h-px bg-aka mx-auto mt-6" />
    </motion.div>
  );
};

export default SectionHeading;
